module.exports = __webpack_public_path__ + "c301b1419a3cc6aa18e4fa69a0071fea.svg";